import {LayerController} from './layer.controller';
import {NGSIResult} from '../../shared/models/ngsi/ngsi-result';
import {catchError, forkJoin, Observable, of, take} from 'rxjs';
import {map} from 'rxjs/operators';
import {Layer} from '../../shared/models/layer.model';
import {Page} from '../../shared/models/page.model';
import {Injector} from '@angular/core';
import {Marker} from '../../shared/models/map/marker.model';
import {NGSIQuery} from '../../shared/models/ngsi/ngsi-query.model';
import {NGSIFilter} from '../../shared/models/ngsi/ngsi-filter.model';
import {QueryOptions} from '../../shared/models/ngsi/query-options';
import {NGSIEntity} from '../../shared/utils/ngsi-result-util';


export class ShipLayerController extends LayerController {
  displaysTooltip: boolean = true;

  constructor(layer: Layer, page: Page, private injector: Injector) {
    super(layer, page, injector);
  }

  protected getDialogContext(result: NGSIResult): any {
    const shipId = this.getShipRefFromNGSIResult(result);
    const shipNo = shipId.substring(shipId.lastIndexOf(':') + 1);
    const queries = [
      this.cbrokerService.getEntity(this.getShipQuery(shipId), new QueryOptions(false)).pipe(catchError(() => of(null))),
      this.cbrokerService.getEntity(this.getSingleQuery(`${shipNo}`, 'ShipEngine'), new QueryOptions(false)).pipe(catchError(() => of(null))),
      this.cbrokerService.getEntity(this.getSingleQuery(`${shipNo}`, 'ShipAmbient'), new QueryOptions(false)).pipe(catchError(() => of(null))),
    ];

    const contextObservable: Observable<any> = forkJoin(queries).pipe(
      take(1),
      map(response => {
        return {
          position: result.getEntityResult().entity,
          ship: response[0]?.getEntityResult().entity[0],
          shipEngine: response[1]?.getEntityResult().entity[0],
          shipAmbient: response[2]?.getEntityResult().entity[0],
        };
      })
    );

    return {
      page: this.popupPage,
      entity: result.getEntityResult(),
      asyncContext: contextObservable
    };
  }

  protected beforeEntitiesProcessed(results: NGSIResult[]): NGSIResult[] {
    const entitiesFound: Set<string> = new Set();
    const finalResults: NGSIResult[] = [];
    results.forEach(result => {
      const shipRef: string = this.getShipRefFromNGSIResult(result);
      if (!entitiesFound.has(shipRef)) {
        finalResults.push(result);
        entitiesFound.add(shipRef);
      }
    });
    return finalResults;
  }

  private getShipRefFromNGSIResult(ngsiResult: NGSIResult): string {
    return ngsiResult.getEntityResult().getSingleElementValue('ref');
  }

  protected getShipQuery(shipId) {
    return new NGSIQuery({
      filter: {
        type: [NGSIEntity.SHIP],
        q: {
          jsonClass: 'NGSIQueryTerm',
          path: {
            jsonClass: 'NGSIPath',
            propOrRelPath: [
              'id'
            ],
            isTemporal: false,
            isPropOrRelArray: false
          },
          op: '==',
          value: [
            shipId
          ]
        }
      },
      limit: 1,
      lastNDays: 365
    });
  }

  protected getSingleQuery(id, type) {
    return new NGSIQuery({
      filter: {
        type: [type],
        q: {
          jsonClass: 'NGSIQueryTerm',
          path: {
            jsonClass: 'NGSIPath',
            propOrRelPath: [
              'id'
            ],
            isTemporal: false,
            isPropOrRelArray: false
          },
          op: '==',
          value: [
            `urn:ngsi-ld:${type}:${id}`
          ]
        }
      },
      limit: 1,
      lastNDays: 365,
      sortField: 'observedAt',
      sortDirection: 'desc'
    });
  }


  createTooltip(marker: Marker): string {
    const id = marker.entity.entity.id;
    const shipNo = id.substring(id.lastIndexOf(':') + 1);
    let html = '<div class="entity-tooltip">';
    html += `<div class="text">${shipNo}</div>`;
    html += '</div';

    return html;
  }

}
